<template>
  <v-overlay
    persistent=""
    z-index="1000"
    scrim="primary"
    opacity="0.7"
    :model-value="$store.state.loading.general"
    class="d-flex justify-center align-center"
  >
    <div class="d-flex flex-column align-center">
      <v-progress-circular
        width="1"
        size="80"
        rounded
        indeterminate
        color="smoke darken-4"
      >
        <v-img
          contain
          width="25"
          :src="require('@/assets/logo/logo-white.svg')"
        ></v-img>
      </v-progress-circular>
      <p
        style="font-size: 12pt; font-weight: 400; color: #fff"
        class="text-center mt-4"
        v-if="$route.path.includes('/create-workspace')"
      >
        {{ text }}
      </p>
    </div>
  </v-overlay>
</template>

<script>
export default {
  data() {
    return {
      tab: 0,
      text: "Creating your workspace...",
    };
  },
  mounted() {
    // setTimeout(function () {
    //   this.tab = 1;
    // }, 500);
  },
};
</script>
